import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Popover, PopoverContent, PopoverTrigger,
} from '@/components/ui/popover';
import { Calendar } from 'lucide-react';

const PRESETS = [
  { value: '30d', label: 'Last 30 Days' },
  { value: '90d', label: 'Last 90 Days' },
  { value: '12m', label: 'Last 12 Months' },
  { value: 'ytd', label: 'Year to Date' },
  { value: 'all', label: 'All Time' },
];

const DateRangeSelect = ({ value, onChange, className = '', testId = 'date-range-filter' }) => {
  const [open, setOpen] = useState(false);
  const [customFrom, setCustomFrom] = useState('');
  const [customTo, setCustomTo] = useState('');

  const handlePreset = (v) => {
    onChange(v);
    setOpen(false);
  };

  const handleCustomApply = () => {
    if (customFrom && customTo) {
      onChange(`custom:${customFrom}:${customTo}`);
      setOpen(false);
    }
  };

  const displayLabel = () => {
    if (value?.startsWith('custom:')) {
      const parts = value.split(':');
      return `${parts[1]} \u2013 ${parts[2]}`;
    }
    return PRESETS.find(p => p.value === value)?.label || 'Date Range';
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className={`h-9 px-3 gap-2 text-sm font-normal ${className}`} data-testid={testId}>
          <Calendar className="h-3.5 w-3.5 text-gray-500" />
          <span className="truncate max-w-[140px]">{displayLabel()}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="end">
        <div className="p-1">
          {PRESETS.map(p => (
            <button key={p.value}
              className={`w-full text-left px-3 py-2 text-sm rounded-md hover:bg-gray-100 transition-colors ${value === p.value ? 'bg-green-50 text-green-700 font-medium' : 'text-gray-700'}`}
              onClick={() => handlePreset(p.value)} data-testid={`date-preset-${p.value}`}>
              {p.label}
            </button>
          ))}
        </div>
        <div className="border-t p-3">
          <p className="text-xs font-medium text-gray-500 mb-2">Custom Range</p>
          <div className="grid grid-cols-2 gap-2">
            <Input type="date" value={customFrom} onChange={e => setCustomFrom(e.target.value)} className="h-8 text-xs" data-testid="custom-date-from" />
            <Input type="date" value={customTo} onChange={e => setCustomTo(e.target.value)} className="h-8 text-xs" data-testid="custom-date-to" />
          </div>
          <Button size="sm" className="w-full mt-2 bg-green-600 hover:bg-green-700 text-white h-8 text-xs" onClick={handleCustomApply} data-testid="apply-custom-date">
            Apply
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default DateRangeSelect;
